import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RegisterSuccess: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div style={{ maxWidth: 500, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, textAlign: 'center' }}>
      <h2 style={{ fontFamily: 'Roboto, sans-serif' }}>{t('registrationSuccessful')}</h2>
      <p style={{ fontSize: 18, margin: '24px 0' }}>
        {t('thankYouForRegistering')}<br />
        {t('pleaseCheckYourEmailAndFollowTheLinkToActivateYourAccount')}
      </p>
      <p style={{ color: '#3baab0', fontWeight: 500 }}>
        {t('afterActivationYouWillBeAbleToLogIn')}
      </p>
      <Link to="/login"  style={{
            width: '100%'
          }}>
        <button
          style={{
            width: '100%',
            height: 39,
            background: 'rgb(59, 170, 176)',
            color: 'rgb(255, 255, 255)',
            border: 'none',
            borderRadius: 4,
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            transition: 'background 0.2s',
            opacity: 1,
          }}
          onMouseOver={e => (e.currentTarget.style.background = '#329a9e')}
          onMouseOut={e => (e.currentTarget.style.background = '#3baab0')}
        >
          {t('signIn')}
        </button>
      </Link>
    </div>
  );
};

export default RegisterSuccess; 